import React, { useEffect } from 'react';
import { Background } from './components/ui/Background';
import { Hero } from './components/sections/Hero';
import { Achievements } from './components/sections/Achievements';
import { Curriculum } from './components/sections/Curriculum';
import { Bonuses } from './components/sections/Bonuses';
import { WhyDifferent } from './components/sections/WhyDifferent';
import { Audience } from './components/sections/Audience';
import { HowItWorks } from './components/sections/HowItWorks';
import { Pricing } from './components/sections/Pricing';
import { Testimonials } from './components/sections/Testimonials';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { initMetaPixel } from './lib/metaPixel';
const META_PIXEL_ID = '2032586933980278';
export function App() {
  useEffect(() => {
    try {
      initMetaPixel(META_PIXEL_ID);
    } catch {
      // El pixel nunca debe afectar el renderizado.
    }
  }, []);
  return <div className="min-h-screen bg-mystic-900 text-white font-sans selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <Background data-id="element-1" />

      <main className="relative" data-id="element-2">
        <Hero data-id="element-3" />
        <Achievements data-id="element-4" />
        <Curriculum data-id="element-5" />
        <Bonuses data-id="element-6" />
        <WhyDifferent data-id="element-7" />
        <Audience data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Pricing data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}